<template>
  <div class="flex-1">
    <router-view />
  </div>
  <copy-right />
</template>
<script>
  import { title } from '@/config'
  import config from '../package.json'
  import CopyRight from '@/components/Copyright'
  export default {
    components: {
      CopyRight,
    },
    data() {
      return {
        version: config.version,
      }
    },
    created() {
      //if (process.env.NODE_ENV !== 'development') {
      // eslint-disable-next-line no-console
      console.log(
        ` %c ${title}v${config.version}  %c by 腾宇一号 `,
        'color: #fadfa3; background: #030307; padding:5px 0;',
        'background: #fadfa3; padding:5px 0;'
      )
      //}
    },
  }
</script>
<style lang="scss">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333;
  }

  #nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #333;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
</style>
